// extracted by mini-css-extract-plugin
module.exports = {"date-calendar":"Calendar_date-calendar__3jXLB"};